import { styled } from 'styled-components';

import Message from '../../../components/Message';

export const MessageWrapper = styled(Message)`
  padding-bottom: var(--spacing-huge);
`;

export const CommentsWrapper = styled.div`
  display: flex;
  flex-flow: column;
  height: 100%;
  justify-content: space-between;
`;
